module.exports = __webpack_public_path__ + "static/media/illustration.01a9f7fb.svg";